module.exports = __webpack_public_path__ + "static/img/karticekorisnikazip2.421c187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/karticekorisnikazip2.png
// module id = lK/u
// module chunks = 0